module.exports = __webpack_public_path__ + "img/edit-white.192d2601.svg";